// extracted by mini-css-extract-plugin
export default {"MainContainer":"App_MainContainer__fPm5E","PageContainer":"App_PageContainer__q31lw","OverflowControl":"App_OverflowControl__aRiUy"};